import React, { useMemo } from "react";
import { HiOutlineViewGrid } from "react-icons/hi";
import {
  formatAudSmart,
  formatCount,
  percentOf,
  truncateLabel,
} from "pages/ServiceProvider/SpSetting/AiCreditsUsage/aiUsageChartUtils";
import PlatformAiUsageBreakdownTrendChart from "./PlatformAiUsageBreakdownTrendChart";
import { mapByFeatureForChart } from "./aiUsageOverview.utils";
import { formatFeatureLabel } from "pages/ServiceProvider/SpSetting/AiCreditsUsage/aiUsageLabels";

const PlatformAiUsageByFeatureChart = ({
  items = [],
  trends = [],
  loading = false,
  error = "",
  from,
  to,
  granularity = "day",
}) => {
  const mappedItems = useMemo(() => mapByFeatureForChart(items), [items]);

  const totals = useMemo(() => {
    const calls = mappedItems.reduce(
      (sum, row) => sum + (Number(row.call_count) || 0),
      0
    );
    const cost = mappedItems.reduce(
      (sum, row) => sum + (Number(row.cost_aud) || 0),
      0
    );
    return { calls, cost };
  }, [mappedItems]);

  const topFeature = mappedItems[0];

  return (
    <PlatformAiUsageBreakdownTrendChart
      title="Usage by feature"
      subtitle="AI call volume by product feature over time"
      icon={HiOutlineViewGrid}
      iconClassName="bg-violet-50 text-violet-600"
      trends={trends}
      keyField="feature_key"
      from={from}
      to={to}
      granularity={granularity}
      loading={loading}
      error={error}
      valueKey="call_count"
      labelFn={(key) => {
        const match = mappedItems.find((row) => row.feature_key === key);
        return match?.label || formatFeatureLabel({ feature_key: key, feature: key });
      }}
      metricItems={
        mappedItems.length > 0
          ? [
              { label: "Total calls", value: formatCount(totals.calls) },
              { label: "Total spend", value: formatAudSmart(totals.cost) },
              {
                label: "Top feature",
                value: topFeature ? truncateLabel(topFeature.label, 28) : "—",
              },
            ]
          : []
      }
      emptyTitle="No usage in this period"
      emptyHint="Run AI features to see a breakdown by feature here."
    />
  );
};

export default PlatformAiUsageByFeatureChart;
